import moment from "moment";
import cyFormat from "@/utils/cyFormat";
const weatherIconSize = 20;
function renderWeather(param: any, api: any) {
  const point = api.coord([param.dataIndexInside, 0]);
  const index = api.value(0);

  return {
    type: "image",
    style: {
      image: `/static/weatherIcon/${cyFormat.getCySkytypeByIndex(
        api.value(0)
      )}.png`,
      x: -weatherIconSize / 2,
      y: -weatherIconSize / 2,
      width: weatherIconSize,
      height: weatherIconSize,
    },
    position: [point[0], 90],
  };
}
const getOption = (data1: number[], data3: Object[]): any => {
  const x: string[] = [];
  const y1: any[] = [];
  for (let i = 0; i < data1.length; i++) {
    const e: any = data1[i];
    x.push(moment(e.date).format("H") + "时");
    y1.push(Math.round(e.value * 10) / 10);
  }

  const fontSize = 14;
  const params: any = {
    animation: true,
    tooltip: {
      trigger: "axis",
      formatter: function(params: any) {
        console.log(params);
        const dataIndex = params[0].dataIndex;
        //@ts-ignore
        const weathcerIcon = data3[dataIndex].value;
        const weathcerName = cyFormat.getSkyconDesc(weathcerIcon);
        const time = params[0].name;
        const value = params[0].data;

        let htmlStr = '<div style="font-weight: bold;">';

        htmlStr += time + "  " + weathcerName + "  " + value + "℃";
        htmlStr += "</div>";

        return htmlStr;
      },
    },
    grid: {
      left: 0,
      right: 0,
      top: 10,
      bottom: 0,
    },
    xAxis: {
      show: false,
      type: "category",
      data: x,
      axisLine: {
        lineStyle: {
          color: "#FFFFFF",
        },
      },
    },
    yAxis: [
      {
        show: false,
        name: "温度/℃",
        type: "value",
        min: (value: any) => Math.round(value.min - 3),
        max: (value: any) => Math.round(value.max + 3),
        // splitNumber: 1,
        splitLine: { show: false },
        axisLine: {
          show: true,
          lineStyle: {
            color: "#FFFFFF",
          },
        },
      },
      {
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { show: false },
        splitLine: { show: false },
      },
    ],
    series: [
      {
        data: y1,
        // symbol: 'circle',
        symbol: "circle",
        symbolSize: 5,
        smooth: true,
        areaStyle: {
          color: "rgba(95, 178, 255, 0.1)",
        },
        label: {
          show: true,
          color: "#5FB2FF",
          fontSize,
          formatter: "{c0}°",
        },
        itemStyle: {
          color: "#5FB2FF",
        },
        type: "line",
        yAxisIndex: 0,
      },
    ],
  };
  // if (data3 && data3.length > 0) {
  //   const y3: any[][] = [];
  //   let temValue = "";

  //   for (let i = 0; i < data3.length; i++) {
  //     const e: any = data3[i];
  //     const value = e.value;
  //     if (temValue !== value) {
  //       y3.push([cyFormat.getSkyconIndex(e.value)]);
  //     }else{
  //       y3.push([])
  //     }
  //     temValue = value;
  //   }
  //   params.series.push({
  //     type: "custom",
  //     renderItem: renderWeather,
  //     data: y3,
  //     // yAxisIndex: 2,
  //     z: 11,
  //   });
  // }
  return params;
};
export default getOption;
